<template>
  <div class="mt-5 mb-5">
    <h5 class="title is-5">
      {{ $t("ReservationForm.coveredByBooking") }}
    </h5>
    <div>{{ $t("ReservationForm.coveredByBookingIntro") }}</div>

    <div class="mt-4">
      <!-- Select All / None -->
      <div class="mb-4">
        <a
          href="#"
          class="u-weight--bold"
          :class="{ 'is-disabled': !canEditExpenses }"
          @click.prevent="canEditExpenses && toggleSelectAll(true)"
          >{{ $t("ReservationForm.selectAllLink") }}</a
        >
        <span class="mx-2"></span>
        <a
          href="#"
          class="u-weight--bold"
          :class="{ 'is-disabled': !canEditExpenses }"
          @click.prevent="canEditExpenses && toggleSelectAll(false)"
          >{{ $t("ReservationForm.selectNoneLink") }}</a
        >
      </div>

      <!-- Expense cards grid -->
      <div class="expense-grid">
        <ExpenseCard
          v-for="item in allExpenses"
          :key="item.type"
          :expense="getExpense(item.type)"
          :label="$t(item.labelKey)"
          :disabled="!canEditExpenses"
          :has-limit-option="item.hasLimit"
          :has-quantity-option="item.type === 'DRINKS'"
          @toggle="updateExpense(item.type, { isCovered: $event })"
          @toggle-no-limit="toggleNoLimit(item.type, $event)"
          @price-input="handlePriceInput(item.type, $event)"
          @quantity-input="handleQuantityInput(item.type, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ExpenseCard from "./ExpenseCard.vue";

export default {
  name: "ExpensesManager",
  components: {
    ExpenseCard
  },
  props: {
    expenses: {
      type: Object,
      required: true,
      default: () => ({
        coveredExpenses: [],
        areAllExpensesCovered: false
      })
    },
    canEditExpenses: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allSelected: false,
      savedExpenseState: null,
      simpleExpenses: [
        {
          type: "ROOM",
          labelKey: "ReservationForm.expenseRoom",
          hasLimit: false
        },
        {
          type: "BREAKFAST",
          labelKey: "ReservationForm.expenseBreakfast",
          hasLimit: false
        },
        {
          type: "PARKING",
          labelKey: "ReservationForm.expenseParking",
          hasLimit: false
        },
        {
          type: "TOURISM_TAX",
          labelKey: "ReservationForm.expenseTourismTax",
          hasLimit: false
        }
      ],
      limitedExpenses: [
        {
          type: "LUNCH",
          labelKey: "ReservationForm.expenseLunch",
          hasLimit: true
        },
        {
          type: "DINNER",
          labelKey: "ReservationForm.expenseDinner",
          hasLimit: true
        },
        {
          type: "DRINKS",
          labelKey: "ReservationForm.expenseDrinks",
          hasLimit: true
        },
        {
          type: "RESTAURANT",
          labelKey: "ReservationForm.expenseRestaurant",
          hasLimit: true
        },
        {
          type: "EXTRAS",
          labelKey: "ReservationForm.expenseExtras",
          hasLimit: true
        }
      ]
    };
  },
  created() {
    if (this.expenses.areAllExpensesCovered) {
      this.allSelected = true;
    }
  },
  computed: {
    allExpenses() {
      return [...this.simpleExpenses, ...this.limitedExpenses];
    }
  },
  methods: {
    getExpense(expenseType) {
      const expense = this.expenses.coveredExpenses.find(
        (e) => e.expenseType === expenseType
      );
      return (
        expense || {
          expenseType: expenseType,
          isCovered: false,
          maxDailyCosts: null,
          maxDailyQuantity: null
        }
      );
    },
    updateExpense(expenseType, updates) {
      this.$emit("update-expense", { expenseType, updates });
    },
    toggleNoLimit(expenseType, hasNoLimit) {
      if (hasNoLimit) {
        this.updateExpense(expenseType, {
          isCovered: true,
          maxDailyCosts: null,
          maxDailyQuantity: null
        });
      } else {
        this.updateExpense(expenseType, {
          isCovered: true,
          maxDailyCosts: 0,
          maxDailyQuantity: null
        });
      }
    },
    toggleSelectAll(checked) {
      this.allSelected = checked;
      if (checked) {
        this.savedExpenseState = this.expenses.coveredExpenses.map((e) => ({
          ...e
        }));
        const allTypes = [
          ...this.simpleExpenses.map((e) => e.type),
          ...this.limitedExpenses.map((e) => e.type)
        ];
        allTypes.forEach((type) => {
          this.updateExpense(type, {
            isCovered: true,
            maxDailyCosts: null,
            maxDailyQuantity: null
          });
        });
      } else {
        const allTypes = [
          ...this.simpleExpenses.map((e) => e.type),
          ...this.limitedExpenses.map((e) => e.type)
        ];
        allTypes.forEach((type) => {
          this.updateExpense(type, {
            isCovered: false,
            maxDailyCosts: null,
            maxDailyQuantity: null
          });
        });
        this.savedExpenseState = null;
      }
      this.$emit("update-expense", {
        expenseType: "_ALL",
        updates: { areAllExpensesCovered: checked }
      });
    },
    handlePriceInput(expenseType, value) {
      this.$emit("handle-price-input", { expenseType, value });
    },
    handleQuantityInput(expenseType, value) {
      this.$emit("handle-quantity-input", { expenseType, value });
    }
  }
};
</script>
